module.exports = __webpack_public_path__ + "assets/img/tobooklink_logo_black.49a873df.svg";